import { query } from "@/utils/api-utils";
import { request } from ".";

export const logsApi = {
  getAll: (params: string) => request("/logs/me"+params),
  exportCsv: (params: string) => request("/logs/export-csv"+params, null, { responseType: "blob" }),
}